import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '@/views/About.vue'
import Welcome from '@/views/Welcome.vue'
import Portfolio from '@/views/Portfolio.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
    props: { collapsed: true }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    props: { collapsed: false }
  },
  {
    path: '/catalogue',
    name: 'Portfolio',
    component: Portfolio,
    props: { collapsed: false }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    props: { collapsed: false }
  },
  {
    path: '/item/:sceneId',
    name: 'Item',
    component: () => import('@/views/PortfolioItem3D.vue'),
    props: true
  },
  {
    path: '/ebslanding',
    name: 'EBSlanding',
    component: () => import('@/views/EBSLanding.vue'),
    props: true
  },
  {
    path: '/pillbottle',
    name: 'PillBottle',
    component: () => import('@/views/PillBottle.vue'),
    props: true
  },
  {
    path: '/avabot',
    name: 'Avabot',
    component: () => import('@/views/Avabot.vue'),
    props: true
  },
  {
    path: '/voiceui',
    name: 'VoiceUI',
    component: () => import('@/views/VoiceUI.vue'),
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return {
        selector: savedPosition,
        behavior: 'smooth'
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
